/** Enum dos eventos de acesso do usuário */
export enum EnumUsuarioEventoAcesso {
  LOGIN = 1,
  LOGOUT = 2,
  LOGIN_FALHA = 3,
  ALTERACAO_SENHA = 4
}
